import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { HomePage } from './HomePage.jsx';
import { lazy } from 'react';
import PlanDetail from './PlanDetail/index.jsx';
import FileViewer from './FileViewer/index.jsx';
import ExpenseDetail from './ExpenseDetail/index.jsx';

const router = createBrowserRouter(
  [
    {
      path: '/plan/:id',
      element: <PlanDetail />,
      children: [
        {
          path: 'expense',
          element: null,
        },
      ],
    },
    // {
    //   path: '/expense/:id',
    //   element: <ExpenseDetail />,
    // },
    {
      path: '/file/viewer',
      element: <FileViewer />,
    },
    {
      path: '/',
      element: <HomePage />,
    },
  ],
  {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);

export function Pages() {
  return (
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true,
        // @ts-ignore type
        v7_relativeSplatPath: true,
        v7_fetcherPersist: true,
      }}
    />
  );
}
